/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Careers_Meta_PageInputs */

const ja_careers_meta_page = /** @type {(inputs: Careers_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`careers`)
};

const en_careers_meta_page = /** @type {(inputs: Careers_Meta_PageInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`careers`)
};

/**
* | output |
* | --- |
* | "careers" |
*
* @param {Careers_Meta_PageInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const careers_meta_page = /** @type {((inputs?: Careers_Meta_PageInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Careers_Meta_PageInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_careers_meta_page(inputs)
	return en_careers_meta_page(inputs)
});